type ToastProps = {
  message: string
  onClose: () => void
}

export function Toast({ message, onClose }: ToastProps) {
  return (
    <div className="fixed right-6 top-6 z-[9999] w-full max-w-sm animate-fade-in-up">
      <div className="flex items-start gap-3 rounded-xl border border-red-200 bg-white px-4 py-3.5 shadow-lg">
        <svg
          className="mt-0.5 h-5 w-5 shrink-0 text-red-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
          />
        </svg>
        <p className="flex-1 text-sm text-gray-dark">{message}</p>
        <button
          type="button"
          onClick={onClose}
          className="ml-1 shrink-0 border-0 bg-transparent p-0 shadow-none outline-none text-gray-400 hover:text-gray-600"
          style={{ boxShadow: 'none', padding: 0, minWidth: '30px' }}
        >
          <svg
            className="h-4 w-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  )
}
